<div class="container">
  @if (currentShow === 'BANNER' && vendorSelected) {
    <div
      class="name"
      (click)="clickOnBanner()"
      style="cursor: pointer"
      nz-tooltip
      nzTooltipPlacement="top"
      nzTooltipTitle="Click to change Vendor"
    >
      <app-vendor-icon
        [vendorCategory]="currentVendor.category ?? 0"
        [asText]="true"
      ></app-vendor-icon>
      <strong [style.color]="currentVendor.name ? '#000' : '#900'">
        {{ currentVendor.name ? currentVendor.name : 'Empty Vendor Name' }}
      </strong>

      @if (currentVendor.description) {
        <div
          nzTooltipPlacement="bottom"
          nz-tooltip
          [nzTooltipTitle]="currentVendor.description.length > 75 ? currentVendor.description : ''"
          class="app-vendor-description"
        >
          <div style="font-size: 10px; color: #a0a0a0; line-height: 12px; margin-left: 20px">
            <strong>{{ currentVendor.location.name }}</strong>
            <br />
            {{ currentVendor.location.address }},
            {{ currentVendor.location.city }}
            {{ currentVendor.location.state }}
            {{ currentVendor.location.zipCode }}
          </div>
        </div>
      }
    </div>
  }

  @if (currentShow === 'BANNER' && !vendorSelected) {
    <div (click)="clickOnBanner()">
      <div style="cursor: pointer">
        <div class="strong">Vendor is not chosen.</div>
        <div>Click here to Select Vendor</div>
      </div>
    </div>
  }

  @if (currentShow === 'FORM' && formType === 'SEARCH') {
    <div>
      <nz-select
        nzShowSearch
        nzServerSearch
        nzPlaceHolder="Type to Search"
        id="vsi"
        #VendorSearchInput
        [nzOptionHeightPx]="70"
        (nzBlur)="clickOnBanner(true)"
        [(ngModel)]="currentVendor"
        [nzShowArrow]="false"
        [nzLoading]="vsLoading"
        (nzOnSearch)="search($event)"
        (ngModelChange)="setVendor(true)"
        style="width: 100%"
      >
        @for (item of foundVendors ?? []; track item) {
          <nz-option nzCustomContent [nzLabel]="item.name" [nzValue]="item">
            <div style="border-bottom: 1px solid #efefef; padding-bottom: 10px">
              <app-vendor-icon
                [vendorCategory]="item.vendor.category"
                [color]="!item.status ? '#c0c0c0' : undefined"
                [asText]="true"
              ></app-vendor-icon>
              <strong [style.color]="!item.status ? '#c0c0c0' : '#000'">
                {{ item.name }}
              </strong>
              <div style="font-size: 10px; color: #a0a0a0; line-height: 12px; margin-left: 20px">
                <strong>{{ item.location.name }}</strong>
                <br />
                {{ item.location.address }},
                {{ item.location.city }}
                {{ item.location.state }}
                {{ item.location.zipCode }}
              </div>
            </div>
          </nz-option>
        }
      </nz-select>
    </div>
  }

  @if (vendorSelected) {
    <div class="resetBtn">
      <button
        nz-button
        nz-popconfirm
        nzPopconfirmTitle="Are you sure?"
        (nzOnConfirm)="resetVendor()"
        nzPopconfirmPlacement="bottom"
        nzDanger
        nzType="default"
        nzSize="small"
      >
        Reset
      </button>
      <button
        nz-button
        [routerLink]="[
          'vendor',
          currentVendor.vendor.category | getCategoryNameById: true,
          'edit',
          currentVendor.vendor.vendorId,
        ]"
        nzType="default"
        nzSize="small"
      >
        <span nz-icon nzType="edit" nzTheme="outline"></span> Details
      </button>
    </div>
  }
</div>
